
import { defineComponent, PropType, computed } from 'vue'
import { TableColumnVariantsEnum, TableColumnVariantsArray, TableColumnHeaderVariantsMap } from '../../components/Table/BTable.types'

export default defineComponent({
  name: 'BTableColumn',
  props: {
    label: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    variant: {
      type: String as PropType<TableColumnVariantsEnum>,
      default: TableColumnVariantsEnum.PRIMARY,
      validator: (prop: TableColumnVariantsEnum) => TableColumnVariantsArray.includes(prop)
    },
  },
  setup(props) {
    const classes = computed(() => TableColumnHeaderVariantsMap[props.variant])

    return {
      classes
    }
  }
})
